import StoresList from "../components/StoresList";
import axios from "axios";
import { useState, useEffect } from "react";

const Home = () => {
  const [location, setLocation] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getLocation();
  }, [loading]);

  const getLocation = async () => {
    await axios.get("https://ipapi.co/json/").then((response) => {
      setLocation(response.data);
      setLoading(false);
    });
  };

  if (loading) return "";
  else
    return (
      <>
        <StoresList location={location} />
      </>
    );
};

export default Home;
